import PageComponent from '../../common/component/page-component';

// Builds accordion sections between Headlines
// finds next headline and collapses content between self and next Accordion component

class AccordionTag extends PageComponent {

	constructor({
								root,
								element,
								accordionAttribute = 'accordion'
							}) {
		super({
			root: root,
			element: element,
			accordionAttribute: accordionAttribute,
		});
		this.accordionAttribute = accordionAttribute;
		this.accordionContent = null;
	}

	prepare() {
		// get all the sibling triggers
		this.accordionTriggers = this.element.parentElement.querySelectorAll(this.dataSelector(this.accordionAttribute));
		for (const accordionTrigger of this.accordionTriggers) {
			let state = accordionTrigger.getAttribute('data-slxh-accordion');
			if (state !== 'end' && accordionTrigger === this.element) {

				// add accordion content element
				this.accordionContent = document.createElement("div");
				this.accordionContent.classList.add('slxh-accordion__content');
				if (state === 'closed') {
					this.classList(this.accordionContent).add('closed');
					this.classList(this.element).add('closed');
				}

				let elem = accordionTrigger.nextSibling;
				let contentElements = [];
				let height = 0;
				while (elem) {
					if (elem.nodeType !== 3) { // ignore text nodes
						if (elem.hasAttribute('data-slxh-accordion')) break; // next accordion reached
						contentElements.push(elem);
						height = height + elem.scrollHeight + 32; // calculte height of elements to set max-height style
					}
					elem = elem.nextSibling;
				}
				// move elements into the accordion content container
				contentElements.forEach((element)=>this.accordionContent.appendChild(element));
				accordionTrigger.parentNode.insertBefore(this.accordionContent, accordionTrigger.nextSibling);
				// set inline for each element for smooth accordion animation
				this.accordionContent.style.maxHeight = height + 'px';
				this.listeners.toggle = this.events.on(this.element, 'click', this.onToggle.bind(this));
			}
		}
	}

	onToggle() {
		// update the height
		if (this.accordionContent.style.maxHeight !== this.accordionContent.scrollHeight) {
			this.accordionContent.style.maxHeight = this.accordionContent.scrollHeight + 'px';
		}
		this.classList(this.accordionContent).toggle('closed');
		this.classList(this.element).toggle('closed');
	}

}

export default AccordionTag;
